import { GoogleLogin } from "@react-oauth/google";
import { useAuth } from "../hooks/useAuth";
import { useToast } from "./ui/use-toast";
import { Button } from "./ui/button";

type SocialAuthButtonsProps = {
  onSuccess?: () => void;
};

const providerIcons = [
  { label: "Facebook", emoji: "📘" },
  { label: "X", emoji: "𝕏" },
  { label: "Yahoo", emoji: "🟣" },
  { label: "Apple", emoji: "" },
  { label: "LinkedIn", emoji: "🔗" },
];

export const SocialAuthButtons = ({ onSuccess }: SocialAuthButtonsProps) => {
  const { loginWithGoogle } = useAuth();
  const { toast } = useToast();
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  const handleGoogleSuccess = async (credential?: string | null) => {
    if (!credential) {
      toast({
        title: "Connexion Google",
        description: "Impossible de récupérer votre jeton d’authentification.",
        variant: "destructive",
      });
      return;
    }
    try {
      await loginWithGoogle(credential);
      toast({
        title: "Connexion Google réussie",
        description: "Bienvenue chez SYNAPSE.",
        variant: "success",
      });
      onSuccess?.();
    } catch (error: any) {
      toast({
        title: "Connexion Google impossible",
        description: error?.message ?? "Veuillez réessayer.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="space-y-5">
      <div className="text-center text-sm font-semibold uppercase tracking-wide text-white/60">
        Inscrivez-vous
      </div>
      <div className="flex flex-col gap-3">
        {googleClientId ? (
          <GoogleLogin
            onSuccess={(response) => handleGoogleSuccess(response.credential)}
            onError={() =>
              toast({
                title: "Connexion Google impossible",
                description: "Veuillez réessayer.",
                variant: "destructive",
              })
            }
          />
        ) : (
          <Button
            type="button"
            disabled
            className="w-full bg-white/10 text-white"
          >
            Google indisponible
          </Button>
        )}
        <div className="flex items-center gap-3 text-white/60">
          <span className="h-px flex-1 bg-white/10" />
          ou
          <span className="h-px flex-1 bg-white/10" />
        </div>
        <div className="flex flex-wrap items-center justify-center gap-3">
          {providerIcons.map((provider) => (
            <button
              key={provider.label}
              type="button"
              disabled
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-white/5 text-lg text-white/70"
            >
              {provider.emoji}
            </button>
          ))}
        </div>
        <Button
          type="button"
          variant="outline"
          className="mt-2 flex items-center justify-center gap-2 text-white"
          disabled
        >
          ✉️ Continuer avec Email
        </Button>
      </div>
    </div>
  );
};

